import { HONEYPOT_FIELD } from "@/lib/honeypot"

/** The spam trap input for a public form (lib/honeypot.ts). Off-screen, out of
 *  the tab order and hidden from assistive tech, so only a bot ever fills it. */
export function HoneypotField() {
  return (
    <div aria-hidden="true" className="pointer-events-none absolute -left-[10000px] top-0 h-px w-px overflow-hidden">
      <input type="text" name={HONEYPOT_FIELD} tabIndex={-1} autoComplete="off" defaultValue="" />
    </div>
  )
}
